import heroBanner from "../../assets/getting-started-hero.png";

export function GettingStartedHeroImage() {
  return (
    <section className="px-[clamp(24px,5vw,80px)] pb-14">
      <div className="mx-auto aspect-[16/9] max-w-[960px] overflow-hidden rounded-[28px] border border-indigo-200 bg-[#E5E2F4] shadow-[0_30px_60px_-30px_rgba(99,102,241,0.35)]">
        <img
          src={heroBanner}
          alt="Summi the elephant working at a vet clinic desk with a veterinarian in the background"
          className="block h-full w-full object-cover object-[center_22%]"
        />
      </div>
    </section>
  );
}
